import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Error',
  data: function data() {
    return {};
  },
  computed: {
    errorMsg: {
      get: function get() {
        // if (this.$store && this.$store.state.errorMsg) {
        //     return `${this.$store.state.errorMsg}，请刷新重试`;
        // }
        // if (this.$route.params.errorInfo) {
        //     return this.$route.params.errorInfo;
        // }
        return '页面出错了，请刷新重试';
      }
    }
  },
  methods: {
    skipIndex: function skipIndex() {
      this.$router.replace('/');
    },
    reload: function reload() {
      location.reload();
    }
  } // beforeRouteLeave(to, from, next) {
  //     // 导航离开该组件的对应路由时调用
  //     this.$store.commit('setErrorMsg', '');
  //     next();
  // }

};